<template>
    <div>
      <span ref="contentDisplay"></span>
      <v-btn
      small
          color="primary"
          class="text-unset"
          style="margin: 0"

        v-if="shouldShowButton"
        @click="toggleText"
        :class="{ 'toggle-gumb': true, 'nova-vrstica': isExpanded }"
      >
        {{ isExpanded ? $t('collapse') : $t('expand') }}
      </v-btn>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ExpandableText',
  
    props: {
      text: {
        type: String,
        required: true // Besedilo je obvezno
      },
      maxLength: {
        type: Number,
        default: 50 // Privzeta vrednost
      }
    },
  
    data() {
      return {
        isExpanded: false,
        fullHtmlContent: '', // Shranimo originalni HTML
        truncatedHtmlContent: '' // Shranimo skrajšan HTML
      };
    },
  
    computed: {
      // Pridobimo čisto besedilo iz HTML-ja, da lahko preverimo dolžino
      fullTextStripped() {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.text;
        return tempDiv.textContent || tempDiv.innerText || '';
      },
      // Določi, ali je gumb sploh potreben
      shouldShowButton() {
        return this.fullTextStripped.length > this.maxLength;
      }
    },
  
    watch: {
      // Poslušamo spremembe na props.text ali isExpanded
      text: {
        immediate: true, // Takoj ob zagonu komponente
        handler() {
          this.processText();
        }
      },
      isExpanded() {
        this.updateContentDisplay();
      }
    },
  
    mounted() {
      // Initial display
      this.updateContentDisplay();
    },
  
    methods: {
      toggleText() {
        this.isExpanded = !this.isExpanded;
      },
  
      // Glavna metoda za procesiranje besedila in ustvarjanje skrajšane verzije
      processText() {
        this.fullHtmlContent = this.text; // Shranimo originalni HTML
  
        if (this.fullTextStripped.length <= this.maxLength) {
          this.truncatedHtmlContent = this.fullHtmlContent; // Če je kratko, ni skrajšanja
          return;
        }
  
        // 1. Parsaj HTML v DOM objekt
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.fullHtmlContent, 'text/html');
        const body = doc.body;
  
        // 2. Rekurzivno prehajamo skozi vozlišča in štejemo znake
        let currentLength = 0;
        const resultNodes = [];
        const openTags = []; // Za sledenje odprtim tagom
  
        // Pomožna rekurzivna funkcija
        const traverseAndTruncate = (node) => {
          if (currentLength >= this.maxLength) {
            return; // Ustavimo se, če smo dosegli maksimalno dolžino
          }
  
          if (node.nodeType === Node.TEXT_NODE) { // Besedilno vozlišče
            const remainingLength = this.maxLength - currentLength;
            if (node.textContent.length > remainingLength) {
              resultNodes.push(document.createTextNode(node.textContent.substring(0, remainingLength)));
              currentLength = this.maxLength; // Dosežena maksimalna dolžina
            } else {
              resultNodes.push(document.createTextNode(node.textContent));
              currentLength += node.textContent.length;
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) { // Elementno vozlišče (tag)
            const newElement = document.createElement(node.tagName);
            // Kopiramo atribute
            for (let i = 0; i < node.attributes.length; i++) {
              const attr = node.attributes[i];
              newElement.setAttribute(attr.name, attr.value);
            }
  
            resultNodes.push(newElement);
  
            // Dodamo tag na seznam odprtih, razen če je self-closing
            const selfClosingTags = ['img', 'br', 'hr', 'input', 'link', 'meta', 'area', 'base', 'col', 'embed', 'keygen', 'param', 'source', 'track', 'wbr'];
            if (!selfClosingTags.includes(node.tagName.toLowerCase())) {
              openTags.push(newElement);
            }
  
            // Rekurzivno za otroke
            for (let i = 0; i < node.childNodes.length; i++) {
              traverseAndTruncate(node.childNodes[i]);
              if (currentLength >= this.maxLength) {
                break; // Ustavimo, če so otroci dosegli dolžino
              }
            }
  
            // Odstranimo tag s seznama odprtih, če je bila celotna vsebina obdelana
            if (currentLength < this.maxLength && openTags[openTags.length - 1] === newElement) {
                openTags.pop(); // Ne zapremo taga, če se nadaljuje znotraj otrok
            }
          }
          // Ignoriramo druge tipe vozlišč (komentarje, itd.)
        };
  
        for (let i = 0; i < body.childNodes.length; i++) {
          traverseAndTruncate(body.childNodes[i]);
          if (currentLength >= this.maxLength) {
            break;
          }
        }
  
        // 3. Zgradimo končni HTML in zapremo vse odprte tage
        let finalHtml = '';
        const tempOutputDiv = document.createElement('div');
  
        resultNodes.forEach(node => {
            tempOutputDiv.appendChild(node.cloneNode(true)); // Kloniramo, da ne uničimo originalnih referenc
        });
  
        // Zapremo vse preostale odprte tage v obratnem vrstnem redu
        while(openTags.length > 0) {
            const lastOpenedTag = openTags.pop();
            // Preverimo, ali je bil tag že zaprt ali je še vedno odprt v drevesu
            // Če se zadnji dodani node ujema z zadnjim odprtim tagom (in ni bil že zaprt),
            // potem ga dejansko zapremo z </tagName>
            // To je tricky del, saj appendChild avtomatično zapre tage,
            // če ne dodamo več vsebine vanje.
            // Najboljši način je ustvariti nov "dummy" root, in dodati elemente vanj
            // Nato pa outerHTML.
        }
  
        // Ta del je kritičen za pravilno zapiranje tagov.
        // DOMParser in appendChild pravilno ravnata z zaključki.
        // Preprosto pridobimo innerHTML iz tempOutputDiv.
        this.truncatedHtmlContent = tempOutputDiv.innerHTML;
      },
  
      // Posodobi vsebino DOM elementa
      updateContentDisplay() {
        if (this.$refs.contentDisplay) {
          if (this.isExpanded) {
            this.$refs.contentDisplay.innerHTML = this.fullHtmlContent;
          } else {
            this.$refs.contentDisplay.innerHTML = this.truncatedHtmlContent + "...";
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Scoped pomeni, da se CSS nanaša samo na to komponento */
  

  
  .toggle-gumb:hover {
    background-color: #0056b3;
  }

  /* Razred za gumb, ko je v novi vrstici */
  .toggle-gumb.nova-vrstica {
    display: block; /* Pokaže se v lastni vrstici */
    margin-top: 15px; /* Večji odmik zgoraj */
    margin-left: 0; /* Odstrani levi odmik, ker je v novi vrstici */
  }
  </style>